import { AxiosResponse } from "axios";
import { api } from "../api";
import { Pedido } from "./ventas.types";

export const getPedidos = async (schoolId?: number): Promise<Pedido[]> => {
  try {
    const limit = 100;
    const allPedidos: Pedido[] = [];
    let page = 1;

    while (true) {
      const params: Record<string, unknown> = { page, limit };
      if (schoolId !== undefined) params.schoolId = schoolId;

      const response: AxiosResponse<Pedido[]> = await api.get(
        "/tienda/admin/pedidos",
        { params }
      );

      if (response.status !== 200) break;

      const batch = response.data;
      allPedidos.push(...batch);

      if (batch.length < limit) break;
      page++;
    }

    return allPedidos;
  } catch (error: any) {
    console.error(error);
    return [];
  }
};
